import { isAfter } from 'date-fns';
import { t } from 'utils/getTranslations';
import { dateStringToDateObject } from 'utils/parseDate';

export function notInFuture(value: string | null, today: Date): true | string {
    return !value || !isAfter(dateStringToDateObject(value), today) || t('client-identification.date-in-future');
}

/** The receipt as a sentence, with the name of who recorded it where the record has one. */
export function receivedLine(date: string, name: string | null): string {
    return name
        ? t('client-identification.received-banner', { date, name })
        : t('client-identification.received-banner-no-name', { date });
}

/** The client confirms its answers no later than they are received, as the backend refuses otherwise. */
export function confirmedByReceipt(value: string | null, receivedOn: string | null, today: Date): true | string {
    const notFuture = notInFuture(value, today);
    if (notFuture !== true || !value || !receivedOn) {
        return notFuture;
    }
    return (
        !isAfter(dateStringToDateObject(value), dateStringToDateObject(receivedOn)) ||
        t('client-identification.confirmed-after-received')
    );
}
